jQuery(document).ready(function(){
	
	
jQuery('.home-slider').slick({
  slidesToShow: 1,
  infinite: true,
  arrows: true,
  autoplay: true,
  prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
  nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
  dots: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  //speed: 500,
  //cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
  /*responsive: [
    {
      breakpoint: 1200,
      settings: {
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: false,
        centerPadding: '0',
        slidesToShow: 1
      }
    }
  ] */
});

jQuery('.work-feed').slick({
  slidesToShow: 7,
  infinite: false,
  centerMode: false,
  arrows: false,
  dots: false,
  draggable: true,
  //swipeToSlide : true,
  //speed: 500,
  //cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
  responsive: [
    {
      breakpoint: 1026,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 760,
      settings: {
        slidesToShow: 3
      }
    }
  ]
});

});